// apps/office/src/lib/pdfUtils.js
import { pdf } from '@react-pdf/renderer';

/**
 * Render a <Document> element into a Blob.
 * @param {React.ReactElement} element
 * @returns {Promise<Blob>}
 */
export async function generatePdfBlob(element) {
  return await pdf(element).toBlob();
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}